import { default as addCpdCategoryConfiguration } from './addCpdCategory';
import { default as addIndustryConfiguration } from './addIndustry';
import { default as addPublisherConfiguration } from './addPublisher';
import { default as addQualificationTypeConfiguration } from './addQualificationType';
import { default as addTaskConfiguration } from './addTask';
import { default as addTaskGroupConfiguration } from './addTaskGroup';
import { default as changeBusinessIndustryConfiguration } from './changeBusinessIndustry';
import { default as changeUserIndustryConfiguration } from './changeUserIndustry';
import { default as cleanBusinessActivitiesConfiguration } from './cleanBusinessActivities';
import { default as cleanReportConfiguration } from './cleanReport';
import { default as copyUserCpdActivityConfiguration } from './copyUserCpdActivity';
import { default as deleteUserConfiguration } from './deleteUser';
import { default as deactivateUserConfiguration } from './deactivateUser';
import { default as deactivateBusinessUserConfiguration } from './deactivateBusinessUser';
import { default as deactivateBusinessConfiguration } from './deactivateBusiness';
import { default as deleteQualificationTypeConfiguration } from './deleteQualificationType';
import { default as estimateCpdAvailabilityConfiguration } from './estimateCpdAvailability';
import { default as estimateUserEngagementConfiguration } from './estimateUserEngagement';
import { default as getAllUserIdsConfiguration } from './getAllUserIds';
import { default as getBusinessActivitiesConfiguration } from './getBusinessActivities';
import { default as getBusinessesConfiguration } from './getBusinesses';
import { default as getBusinessReportConfiguration } from './getBusinessReport';
import { default as getBusinessUsersConfiguration } from './getBusinessUsers';
import { default as getContentCompletionConfiguration } from './getContentCompletion';
import { default as getContentReportConfiguration } from './getContentReport';
import { default as getContentRatingReportConfiguration } from './getContentRatingReport';
import { default as getExternalUsersConfiguration } from './getExternalUsers';
import { default as getIndustryCpdCategoryConfiguration } from './getIndustryCpdCategory';
import { default as getMockUserConfiguration } from './getMockUser';
import { default as getReportConfiguration } from './getReport';
import { default as getSnapshotReportConfiguration } from './getSnapshotReport';
import { default as getUserDataConfiguration } from './getUserData';
import { default as getUsersConfiguration } from './getUsers';
import { default as getUsersFromEmailsConfiguration } from './getUsersFromEmails';
import { default as loadMoreAdminTaskGroupsConfiguration } from './loadMoreAdminTaskGroups';
import { default as loadMoreAdminTasksConfiguration } from './loadMoreAdminTasks';
import { default as queryAdminTaskGroupConfiguration } from './queryAdminTaskGroups';
import { default as queryAdminTaskConfiguration } from './queryAdminTasks';
import { default as removeFailedUserQuizConfiguration } from './removeFailedUserQuiz';
import { default as snapshotUserTrainingPlanConfiguration } from './snapshotUserTrainingPlan';
import { default as updateAdminTaskConfiguration } from './updateAdminTask';
import { default as updateBusinessNotesConfiguration } from './updateBusinessNotes';
import { default as updateBusinessUploadCpdWithoutApprovalConfiguration } from './updateBusinessUploadCpdWithoutApproval';
import { default as updateCpdCategoryConfiguration } from './updateCpdCategory';
import { default as updateCpdPointStatusConfiguration } from './updateCpdPointStatus';
import { default as updateIndustryConfiguration } from './updateIndustry';
import { default as updatePublisherConfiguration } from './updatePublisher';
import { default as updateQualificationTypeConfiguration } from './updateQualificationType';
import { default as uploadExternalCpdConfiguration } from './uploadExternalCpd';
import { default as getUserCpdProgressReportConfiguration } from './getUserCpdProgressReport';
import { default as resetUserCpdProgressReportConfiguration } from './resetUserCpdProgressReport';
import { default as downloadUserCpdProgressReportConfiguration } from './downloadUserCpdProgressReport';
import { default as sendUserCpdProgressNotification } from './sendUserCpdProgressNotification';
import { default as getUsersInBusinessConfiguration } from './getUsersInBusiness';
import { default as assignUserRoleConfiguration } from './assignUserRole';
import { default as disassociateUserRoleConfiguration } from './disassociateUserRole';

export const configurations = [
  addPublisherConfiguration,
  cleanBusinessActivitiesConfiguration,
  cleanReportConfiguration,
  getUsersConfiguration,
  getBusinessUsersConfiguration,
  getBusinessesConfiguration,
  getReportConfiguration,
  getBusinessActivitiesConfiguration,
  getBusinessReportConfiguration,
  getUserDataConfiguration,
  getContentReportConfiguration,
  getContentRatingReportConfiguration,
  changeUserIndustryConfiguration,
  changeBusinessIndustryConfiguration,
  updateIndustryConfiguration,
  addCpdCategoryConfiguration,
  updateCpdCategoryConfiguration,
  getIndustryCpdCategoryConfiguration,
  updatePublisherConfiguration,
  addIndustryConfiguration,
  removeFailedUserQuizConfiguration,
  uploadExternalCpdConfiguration,
  getUsersFromEmailsConfiguration,
  getMockUserConfiguration,
  getAllUserIdsConfiguration,
  estimateCpdAvailabilityConfiguration,
  estimateUserEngagementConfiguration,
  addTaskConfiguration,
  queryAdminTaskConfiguration,
  updateAdminTaskConfiguration,
  loadMoreAdminTasksConfiguration,
  addTaskGroupConfiguration,
  queryAdminTaskGroupConfiguration,
  loadMoreAdminTaskGroupsConfiguration,
  updateCpdPointStatusConfiguration,
  getContentCompletionConfiguration,
  snapshotUserTrainingPlanConfiguration,
  getSnapshotReportConfiguration,
  deleteUserConfiguration,
  deactivateUserConfiguration,
  deactivateBusinessUserConfiguration,
  deactivateBusinessConfiguration,
  addQualificationTypeConfiguration,
  updateQualificationTypeConfiguration,
  deleteQualificationTypeConfiguration,
  getUserCpdProgressReportConfiguration,
  resetUserCpdProgressReportConfiguration,
  downloadUserCpdProgressReportConfiguration,
  sendUserCpdProgressNotification,
  getUsersInBusinessConfiguration,
  assignUserRoleConfiguration,
  disassociateUserRoleConfiguration,
  copyUserCpdActivityConfiguration,
  getExternalUsersConfiguration,
  updateBusinessNotesConfiguration,
  updateBusinessUploadCpdWithoutApprovalConfiguration,
]


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/index.js